import React, { PureComponent } from 'react';
import leftArrow from '@assets/common/arrowLeft.png';
import styles from './index.module.css';
import PropTypes from 'prop-types';

class BackArrowIcon extends PureComponent {
  render() {
    return (
      <img
        src={leftArrow}
        alt="go back"
        className={this.props.className || styles.navIcon}
        onClick={this.props.onClick}
      />
    );
  }
}

BackArrowIcon.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
}
export default BackArrowIcon;
